import Typography from '@mui/material/Typography';
import React from 'react';

import { Box } from '@mui/material';
import { AccessPointData, PermissionData } from '../../api/types';
import { PermissionGainAccess } from './PermissionGainAccess';
import { PermissionsMissingValue } from './PermissionsMissingValue';

interface PermissionContentProps {
    accessInformation: AccessPointData;
    permissionInfo: PermissionData;
    readOnly: boolean;
    translations: Record<string, string>;
}

export const PermissionContent: React.FC<PermissionContentProps> = ({
    accessInformation,
    permissionInfo,
    readOnly,
    translations,
}) => (
    <>
        <Typography variant={'subtitle1'} fontWeight={600} gutterBottom>
            {translations.ACCESS_POINT_MISSING_PERMISSIONS_TITLE} {permissionInfo.permissionCode}
        </Typography>

        <Typography variant={'subtitle2'} color="textSecondary" gutterBottom>
            {permissionInfo.permissionDescription}
        </Typography>

        <PermissionGainAccess
            accessPointCode={accessInformation.accessPointCode}
            readOnly={readOnly}
            permissionInfo={permissionInfo}
            translations={translations}
        />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
            <PermissionsMissingValue
                accessPointCode={accessInformation.accessPointCode}
                readOnly={readOnly}
                permissionInfo={permissionInfo}
                subtitle={translations.PERMISSIONS_MISSING_PERMITS_SUBTITLE}
                translations={translations}
                missingKey="missingPermits"
            />

            <PermissionsMissingValue
                accessPointCode={accessInformation.accessPointCode}
                readOnly={readOnly}
                permissionInfo={permissionInfo}
                subtitle={translations.PERMISSIONS_MISSING_RANKS_SUBTITLE}
                translations={translations}
                missingKey="missingRanks"
            />
        </Box>
    </>
);
